import { styled } from '@mui/material/styles'

const Grid = styled('section')`
  display: grid;
  grid-template-columns: min( 40%, 500px ) 3fr;
  grid-gap: 4vw;
`

export default Grid
